// extracted by mini-css-extract-plugin
export default {"page":"PrivacyPolicyScreen_page__ymtHL","container":"PrivacyPolicyScreen_container__xzvkS","updated":"PrivacyPolicyScreen_updated__ufY-b","back":"PrivacyPolicyScreen_back__1x+hc"};